import { render } from "./dataList.vue?vue&type=template&id=832db464&scoped=true"
import script from "./dataList.vue?vue&type=script&lang=js"
export * from "./dataList.vue?vue&type=script&lang=js"

import "./dataList.vue?vue&type=style&index=0&id=832db464&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-832db464"

export default script